(() => {
// The sign-in pages: login, create account, reset password.
//
// Everything here is an improvement on forms that already work without it.
// The tabs are links, the forms post normally and the server checks every
// rule again, so a visitor without JavaScript loses the conveniences and
// nothing else.
function $f55c656d173bf7c9$var$passwordToggles() {
    for (const button of document.querySelectorAll('[data-password-toggle]')){
        const input = document.getElementById(button.dataset.passwordToggle);
        if (!input) continue;
        const icon = button.querySelector('i');
        button.addEventListener('click', ()=>{
            const show = input.type === 'password';
            input.type = show ? 'text' : 'password';
            button.setAttribute('aria-pressed', String(show));
            button.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
            if (icon) {
                icon.classList.toggle('fa-eye', !show);
                icon.classList.toggle('fa-eye-slash', show);
            }
            input.focus();
        });
    }
}
/**
 * The two passwords on a form with a confirmation field have to match. Said
 * by the browser's own validation, so it blocks the submit and is read out
 * like any other invalid field, and only once the second one has been typed.
 */ function $f55c656d173bf7c9$var$confirmMatch(form) {
    const password = form.querySelector('input[name="password"]');
    const confirm = form.querySelector('input[name="confirm"]');
    if (!password || !confirm) return;
    const check = ()=>{
        const mismatch = confirm.value && confirm.value !== password.value;
        confirm.setCustomValidity(mismatch ? 'The passwords do not match.' : '');
    };
    password.addEventListener('input', check);
    confirm.addEventListener('input', check);
}
/** One press, one request: the button waits and says so. */ function $f55c656d173bf7c9$var$busyOnSubmit(form) {
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;
    form.addEventListener('submit', ()=>{
        // A form the browser refused never gets here, so this only runs for
        // a request that is actually leaving.
        button.disabled = true;
        const label = form.dataset.busyLabel;
        if (label) {
            button.innerHTML = '<i class="fa-solid fa-circle-notch fa-spin" aria-hidden="true"></i>';
            button.appendChild(document.createTextNode(` ${label}`));
        }
    });
}
/** The login page's two tabs, switched in place and kept in the address. */ function $f55c656d173bf7c9$var$authTabs() {
    const root = document.getElementById('authRoot');
    if (!root) return;
    const tabs = document.querySelectorAll('[data-authtab]');
    const panels = document.querySelectorAll('[data-authpanel]');
    const title = document.querySelector('[data-auth-title]');
    const text = document.querySelector('[data-auth-text]');
    function activate(mode, focusField) {
        for (const tab of tabs)tab.setAttribute('aria-selected', String(tab.dataset.authtab === mode));
        for (const panel of panels)panel.hidden = panel.dataset.authpanel !== mode;
        if (title) title.textContent = root.dataset[`${mode}Title`];
        if (text) text.textContent = root.dataset[`${mode}Text`];
        document.title = root.dataset[`${mode}Doc`];
        history.replaceState(null, '', mode === 'register' ? '/login?mode=register' : '/login');
        // An error shown for one form says nothing about the other.
        for (const alert of root.querySelectorAll('[role="alert"]'))alert.remove();
        if (focusField) {
            const field = document.querySelector(`[data-authpanel="${mode}"] input[type="email"]`);
            if (field && !field.value) field.focus();
        }
    }
    for (const tab of tabs){
        tab.addEventListener('click', (event)=>{
            event.preventDefault();
            activate(tab.dataset.authtab, true);
        });
        // Arrow keys move between tabs, as a tablist promises.
        tab.addEventListener('keydown', (event)=>{
            if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
            event.preventDefault();
            const next = [
                ...tabs
            ].find((t)=>t !== tab);
            next.focus();
            activate(next.dataset.authtab, false);
        });
    }
}
function $f55c656d173bf7c9$var$init() {
    $f55c656d173bf7c9$var$passwordToggles();
    $f55c656d173bf7c9$var$authTabs();
    for (const form of document.querySelectorAll('form[data-busy-label]')){
        $f55c656d173bf7c9$var$confirmMatch(form);
        $f55c656d173bf7c9$var$busyOnSubmit(form);
    }
    // Coming back through the history restores the page as it was left, a
    // waiting button included. Loading it fresh makes it usable again.
    window.addEventListener('pageshow', (event)=>{
        if (event.persisted) window.location.reload();
    });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $f55c656d173bf7c9$var$init);
else $f55c656d173bf7c9$var$init();

})();
//# sourceMappingURL=auth.d1145b8f.js.map
